import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ReactDataTable from "react-data-table-component";
import {
  IconEdit,
  IconFilter,
  IconTrash,
  IconDownload,
} from "@tabler/icons-react";
import {
  DeleteEmployee,
  getCategorys,
  getCompanys,
  getDepartments,
  getDesignation,
  sendemployeedeletionotp,
  downloadEmployeeData,
  getAllEmployee,
  getProfitCenter,
  getEmpStatus,
} from "../../services/dataService";
import { IMAGE_URL } from "../../services/apiGateway";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import AddEmployeeModal from "./AddEmployeeModal";
import FilterComponent from "../pages/FilterComponent";
import { Link, useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { tempState } from "../../atom/atom";

export default function Employee2() {
  const UID = localStorage.getItem("userId");
  const departmentIds = localStorage.getItem("DepartmentId") || ""; // Retrieve the value or default to an empty string
  const DepId = departmentIds.split(",")[0] || null; // Split and get the first ID, or set to null if not found
  const isAdmin = localStorage.getItem("IsAdmin");
  const [filterText, setFilterText] = React.useState("");
  const [loadingpdf, setLoadingpdf] = useState(false);
  const [moadaopenClr, setModalOpenClr] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const [dataFilter, setDataFilter] = useState([]);
  const [payScaleFilter, setPayScaleFilter] = useState("all"); // New state for PayScaleId filter
  const [department, setDepartment] = useState([]);
  const [company, setCompany] = useState([]);
  const [isAddEmployeeVisible, setIsAddEmployeeVisible] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [employeeId, setEmployeeId] = useState();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [designation, setDesignation] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imagePreview, setImagePreview] = useState(null);
  const [employee, setEmployee] = useState([]);
  const [EmpIdToDelete, setEmpIdToDelete] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [category, setCategory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState("");
  const [ProfitCenter, setProfitCenter] = useState([]);
  const [employeeType, setEmployeeType] = useState([]);
  const [documentDetails, setDocumentDetails] = useState({
    EmpId: "",
    DocId: "",
    Doc: null,
    UserId: UID,
  });
  const location = useLocation();
  const [notfinanceemployee, setNotFinanceEmployee] = useState(
    () => location.state?.notfinanceemployee || []
  );
  const [bankDetails, setBankDetails] = useState({
    BankName: "",
    AccNo: "",
    BranchName: "",
    IFSC: "",
    EmpId: "",
    NomineeName: "",
    UserId: UID,
  });
  const [personalDetails, setPersonalDetails] = useState({
    CurrentAddress: "",
    PermanentAddress: "",
    Experience: "",
    BloodGrp: "",
    PFNo: "",
    FatherorHus: "",
    NomineeName: "",
    NomineeAge: "",
    NomineeAadhar: "",
    Relationship: "",
    NomiNeeAddress: "",
    EmpId: employeeId,
    Qualification: "",
    UAN: "",
    PAN: "",
    Nationality: "",
    Religion: "",
    UserId: "",
    Caste: "",
    UserId: UID,
  });

  const [employeeDetails, setEmployeeDetails] = useState({
    Name: "",
    Code: "",
    EmployeeId: "",
    GenderId: "",
    DOJ: "",
    DOR: "",
    ProfitCenterId: "",
    DepartmentId: "",
    CategoryId: "",
    GroupId: "",
    DesignationId: "",
    EmployTypeId: "",
    PayScaleId: "",
    SalaryGeneration: "",
    ContractEndDate: "",
    UserId: UID,
    DepartmentName: "",
    ProfitcenterName: "",
    Mobile2: "",
    CategoryId: "",
    Mobile: "",
    AadharNo: "",
    Narration: "",
    ShiftId: "",
    EmpStatus: "",
  });
  const [temp, setTemp] = useRecoilState(tempState);

  const generateEmployeePDF = async (employeeData) => {
    const doc = new jsPDF({
      unit: "mm",
      format: "a4",
      compress: true,
    });

    // Set margins
    const margin = 10;
    let yPos = margin;
    const titleOffset = 17;
    const pageWidth = 210; // A4 width
    const usableWidth = pageWidth - margin * 2;

    // Title with underline
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("EMPLOYEE DETAILS", pageWidth / 2, yPos + titleOffset, {
      align: "center",
    });
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.8);
    doc.line(60, yPos + titleOffset + 2, 150, yPos + titleOffset + 2);
    yPos += 12;

    try {
      const profileImageUrl = extractProfileImage(employeeData.Documents);

      if (profileImageUrl) {
        const imgWidth = 25;
        const imgHeight = 25;
        // const imgX = (pageWidth - imgWidth) / 2; //center
        // const imgX = pageWidth - margin - imgWidth; //right aligned
        const imgX = 40 - imgWidth;
        const imgY = yPos;

        try {
          // Try the primary image loading method
          let imgData;
          try {
            imgData = await loadImage(profileImageUrl);
          } catch (primaryError) {
            imgData = await loadImageWithFetch(profileImageUrl);
          }

          // Draw border rectangle
          doc.setDrawColor(100, 100, 100);
          doc.setLineWidth(0.5);
          doc.roundedRect(
            imgX - 1,
            imgY - 1,
            imgWidth + 2,
            imgHeight + 2,
            2,
            2,
            "S"
          );

          // Add image to PDF
          doc.addImage(imgData, "JPEG", imgX, imgY, imgWidth, imgHeight);

          // Add "Photo" label below the image
          doc.setFontSize(8);
          doc.setTextColor(100, 100, 100);
          doc.text("Photo", imgX + imgWidth / 2, imgY + imgHeight + 4, {
            align: "center",
          });
        } catch (imgError) {
          console.error("Failed to add image to PDF:", imgError);

          // Add placeholder rectangle if image fails to load
          doc.setFillColor(240, 240, 240);
          doc.setDrawColor(200, 200, 200);
          doc.setLineWidth(0.5);
          doc.rect(imgX, imgY, imgWidth, imgHeight, "FD");

          // Add placeholder text
          doc.setFontSize(6);
          doc.setTextColor(150, 150, 150);
          doc.text("Photo", imgX + imgWidth / 2, imgY + imgHeight / 2 - 2, {
            align: "center",
          });
          doc.text(
            "Not Available",
            imgX + imgWidth / 2,
            imgY + imgHeight / 2 + 2,
            { align: "center" }
          );

          // Add "Photo" label below the placeholder
          doc.setFontSize(8);
          doc.text("Photo", imgX + imgWidth / 2, imgY + imgHeight + 4, {
            align: "center",
          });
        }
      } else {
        // Add placeholder when no image is available
        const imgWidth = 25;
        const imgHeight = 25;
        const imgX = pageWidth - margin - imgWidth;
        const imgY = yPos;

        doc.setFillColor(245, 245, 245);
        doc.setDrawColor(200, 200, 200);
        doc.setLineWidth(0.5);
        doc.rect(imgX, imgY, imgWidth, imgHeight, "FD");

        doc.setFontSize(6);
        doc.setTextColor(150, 150, 150);
        doc.text("No Photo", imgX + imgWidth / 2, imgY + imgHeight / 2, {
          align: "center",
        });

        // Add "Photo" label
        doc.setFontSize(8);
        doc.text("Photo", imgX + imgWidth / 2, imgY + imgHeight + 4, {
          align: "center",
        });
      }
    } catch (error) {
      console.error("Error in image processing section:", error);

      // Add placeholder on any error
      const imgWidth = 25;
      const imgHeight = 25;
      const imgX = pageWidth - margin - imgWidth;
      const imgY = yPos;

      doc.setFillColor(245, 245, 245);
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.5);
      doc.rect(imgX, imgY, imgWidth, imgHeight, "FD");

      doc.setFontSize(6);
      doc.setTextColor(150, 150, 150);
      doc.text("Error", imgX + imgWidth / 2, imgY + imgHeight / 2, {
        align: "center",
      });

      doc.setFontSize(8);
      doc.text("Photo", imgX + imgWidth / 2, imgY + imgHeight + 4, {
        align: "center",
      });
    }

    // Adjust yPos for the table to ensure it doesn't collide with the photo
    // We'll start the table content below whichever is lower - the title or the photo
    const minYStart = Math.max(yPos + 5, yPos + 32); // 25mm image + 5mm padding
    yPos = minYStart;

    // Helper function to create section header
    const createSectionHeader = (title, y) => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.setFillColor(240, 240, 240);
      doc.rect(margin, y, usableWidth, 6, "FD");
      doc.setTextColor(0, 0, 0);
      doc.text(title, margin + 2, y + 4);
      return y + 6;
    };

    // Helper function to create two-column table
    const createTwoColumnTable = (data, startY) => {
      const leftColumnData = [];
      const rightColumnData = [];

      // Split data into two columns
      for (let i = 0; i < data.length; i++) {
        if (i % 2 === 0) {
          leftColumnData.push(data[i]);
        } else {
          rightColumnData.push(data[i]);
        }
      }

      // Ensure both columns have equal length
      while (leftColumnData.length > rightColumnData.length) {
        rightColumnData.push(["", ""]);
      }
      while (rightColumnData.length > leftColumnData.length) {
        leftColumnData.push(["", ""]);
      }

      // Combine columns for table
      const combinedData = [];
      for (let i = 0; i < leftColumnData.length; i++) {
        combinedData.push([
          leftColumnData[i][0],
          leftColumnData[i][1],
          rightColumnData[i][0],
          rightColumnData[i][1],
        ]);
      }

      doc.autoTable({
        startY: startY,
        body: combinedData,
        styles: {
          fontSize: 9,
          cellPadding: 2,
          overflow: "linebreak",
          lineColor: [0, 0, 0],
          lineWidth: 0.3,
          textColor: [0, 0, 0],
          fillColor: [255, 255, 255],
        },
        columnStyles: {
          0: {
            fontStyle: "bold",
            cellWidth: 45,
            fillColor: [250, 250, 250],
          },
          1: {
            cellWidth: 50,
            fillColor: [255, 255, 255],
          },
          2: {
            fontStyle: "bold",
            cellWidth: 45,
            fillColor: [250, 250, 250],
          },
          3: {
            cellWidth: 50,
            fillColor: [255, 255, 255],
          },
        },
        theme: "grid",
        tableWidth: usableWidth,
        margin: { left: margin },
      });

      return doc.lastAutoTable.finalY;
    };

    // Employee Information Section
    yPos = createSectionHeader("Employee Information", yPos);

    const basicInfo = [
      ["Name", employeeData.Name || "N/A"],
      ["Employee Code", employeeData.Code || "N/A"],
      ["Gender", employeeData.Gender || "N/A"],
      ["Date of Joining", formatDate(employeeData.Doj)],
      ["Date of Birth", formatDate(employeeData.DOB)],
      ["Retirement Date", formatDate(employeeData.DateOfRetirement)],
      ["Company", employeeData.CompanyName || "N/A"],
      ["Department", employeeData.DepartmentName || "N/A"],
      ["Designation", employeeData.DesignationName || "N/A"],
      ["Category", employeeData.CategoryName || "N/A"],
      ["Pay Scale", employeeData.PayScaleName || "N/A"],
      [
        "Current Basic Pay",
        employeeData.Currentbasicpay
          ? `${employeeData.Currentbasicpay}.00`
          : "0",
      ],
      [
        "Salary Amount",
        employeeData.SalaryAmount ? `${employeeData.SalaryAmount}.00` : "0",
      ],
      // ['Employee ID', employeeData.EmployeeId || 'N/A']
    ];

    yPos = createTwoColumnTable(basicInfo, yPos) + 5;

    // Contact & Personal Information Section
    yPos = createSectionHeader("Contact & Personal Information", yPos);

    const contactInfo = [
      ["Permanent Address", employeeData.PermanentAddress || "N/A"],
      ["Current Address", employeeData.CurrentAddress || "N/A"],
      ["Mobile Number", employeeData.Mobile || "N/A"],
      ["Alternate Phone", employeeData.Mobile2 || "N/A"],
      ["Email", employeeData.Email || "N/A"],
      ["Father/Husband Name", employeeData.FatherOrHusbandName || "N/A"],
      ["Nominee Name", employeeData.NomineeName || "N/A"],
      ["Blood Group", employeeData.BloodGroup || "N/A"],
      ["Qualification", employeeData.Qualification || "N/A"],
      [
        "Experience",
        employeeData.Experience ? `${employeeData.Experience} years` : "N/A",
      ],
      ["Nationality", employeeData.Nationality || "N/A"],
      ["Aadhar Number", employeeData.AadharNo || "N/A"],
      // ['Religion', employeeData.Religion || 'N/A'],
      // ['Caste', employeeData.Caste || 'N/A']
    ];

    yPos = createTwoColumnTable(contactInfo, yPos) + 5;

    // Check if we need a new page for bank information
    if (yPos > 220) {
      doc.addPage();
      yPos = margin;
    }

    // Bank Information Section
    yPos = createSectionHeader("Bank Information", yPos);

    const bankInfo = [
      ["Bank Name", employeeData.BankName || "N/A"],
      ["Account Number", employeeData.AccNo || "N/A"],
      ["Branch Name", employeeData.BranchName || "N/A"],
      ["IFSC Code", employeeData.IFSC || "N/A"],
      // ['PF Number', employeeData.PFNo || 'N/A'],
      // ['UAN Number', employeeData.UAN || 'N/A'],
      // ['PAN Number', employeeData.PAN || 'N/A'],
      ["", ""], // Empty row to balance columns
    ];

    yPos = createTwoColumnTable(bankInfo, yPos) + 5;

    // Additional Information if available
    if (employeeData.Narration) {
      if (yPos > 240) {
        doc.addPage();
        yPos = margin;
      }

      yPos = createSectionHeader("Additional Information", yPos);

      doc.autoTable({
        startY: yPos,
        body: [["Narration", employeeData.Narration]],
        styles: {
          fontSize: 9,
          cellPadding: 3,
          overflow: "linebreak",
          lineColor: [0, 0, 0],
          lineWidth: 0.3,
          textColor: [0, 0, 0],
          fillColor: [255, 255, 255],
        },
        columnStyles: {
          0: {
            fontStyle: "bold",
            cellWidth: 40,
            fillColor: [250, 250, 250],
          },
          1: {
            cellWidth: 150,
            fillColor: [255, 255, 255],
          },
        },
        theme: "grid",
        tableWidth: usableWidth,
        margin: { left: margin },
      });
    }

    // Add footer with generation date and page numbers
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(100, 100, 100);
      doc.text(
        `Generated on: ${new Date().toLocaleDateString("en-IN")}`,
        margin,
        285
      );
      doc.text(`Page ${i} of ${pageCount}`, pageWidth - margin - 20, 285);
    }

    // Save the PDF with a clean filename
    const cleanName = employeeData.Name
      ? employeeData.Name.replace(/[^a-zA-Z0-9\s]/g, "").replace(/\s+/g, "_")
      : "Employee";
    const cleanCode = employeeData.Code
      ? employeeData.Code.replace(/[^a-zA-Z0-9]/g, "_")
      : "Unknown";
    doc.save(`Employee_${cleanCode}_${cleanName}.pdf`);
  };

  // Helper function to extract profile image URL
  function extractProfileImage(documentsString) {
    if (!documentsString) {
      return null;
    }

    try {
      // Split by semicolon to handle multiple documents
      const documents = documentsString.split(";");

      // Find any image document (look for Photo or image extensions)
      const imageDoc = documents.find((doc) => {
        const parts = doc.split(":");

        if (parts.length >= 3) {
          // Check if the second part contains "Photo" or if the filename has image extension
          const docType = parts[1]; // This should be "Photo"
          const filename = parts[2]; // This should be the filename
          const ext = filename.split(".").pop().toLowerCase();

          // Check if it's a photo type or has image extension
          return (
            docType.toLowerCase() === "photo" ||
            ["jpg", "jpeg", "png", "gif", "bmp"].includes(ext)
          );
        }
        return false;
      });

      if (imageDoc) {
        const parts = imageDoc.split(":");
        const filename = parts[2];
        const fullUrl = `${IMAGE_URL}/${filename}`;
        //const fullUrl = `http://localhost:5009/uploads/${filename}`;
        return fullUrl;
      } else {
      }
    } catch (error) {
      console.error("Error extracting profile image:", error);
    }
    return null;
  }

  // Enhanced image handling functions
  async function loadImage(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();

      // Set crossOrigin before setting src
      img.crossOrigin = "anonymous";

      img.onload = () => {
        try {
          // Create canvas to handle different image formats and ensure compatibility
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          // Set canvas dimensions
          canvas.width = img.width;
          canvas.height = img.height;

          // Draw image to canvas
          ctx.drawImage(img, 0, 0);

          // Convert to data URL that jsPDF can handle
          const dataUrl = canvas.toDataURL("image/jpeg", 0.9);
          resolve(dataUrl);
        } catch (canvasError) {
          console.error("Canvas processing error:", canvasError);
          reject(new Error("Failed to process image"));
        }
      };

      img.onerror = (err) => {
        console.error("Image loading failed:", err);
        console.error("Failed URL:", url);
        reject(new Error(`Failed to load image: ${url}`));
      };

      // Add cache buster and set source
      const cacheBusterUrl =
        url + (url.includes("?") ? "&" : "?") + "t=" + Date.now();
      img.src = cacheBusterUrl;

      // Add timeout to prevent hanging
      setTimeout(() => {
        if (!img.complete) {
          console.error("Image loading timeout");
          reject(new Error("Image loading timeout"));
        }
      }, 10000); // 10 second timeout
    });
  }
  async function loadImageWithFetch(url) {
    try {
      const response = await fetch(url, {
        mode: "cors",
        credentials: "omit",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = () => {
          console.error("FileReader error");
          reject(new Error("Failed to convert blob to data URL"));
        };
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Fetch approach failed:", error);
      throw error;
    }
  }
  // Helper function to format date
  function formatDate(dateString) {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN");
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
    localStorage.setItem("myTablePage", page);
  };

  const employeeOne = async () => {
    try {
      // Set loading to true before starting the fetch
      setLoading(true);

      // Await the employee data retrieval
      const employeeData = await getAllEmployee(UID);

      // Process the employee data if needed
      // For example:
      if (employeeData) {
        // Update state with employee details
        setEmployeeDetails(employeeData);
      }

      // Set loading to false once data is fetched
      setLoading(false);

      return employeeData;
    } catch (error) {
      // Handle any errors during fetching
      console.error("Error fetching employee:", error);

      // Ensure loading is set to false even if there's an error
      setLoading(false);

      // Optionally show an error notification
      // toast.error('Failed to fetch employee details');

      return null;
    }
  };

  const closeAddEmployeeModal = () => {
    setIsAddEmployeeVisible(false);
  };

  const openAddEmployeeModal = (isEdit, employeeData) => {
    setIsAddEmployeeVisible(true);
    setIsEdit(isEdit);
    setEmployeeId(0);

    if (isEdit) {
      setEmployeeDetails(employeeData);
    } else {
      setEmployeeDetails(null);
    }
  };

  // const tableData = location.state ? location.state.notfinanceemployee : dataFilter;

  const filteredItems = dataFilter?.filter((item) => {
    const companyName = company?.find((el) => el.Id == item?.CompanyId)?.Name;
    const departmentName = department?.find(
      (el) => el.Id === item?.DepartmentId
    )?.Name;
    const categoryName = category?.find(
      (el) => el.Id === item?.CategoryId
    )?.Name;
    const desigName = designation?.find(
      (el) => el.Id === item?.DesignationId
    )?.Name;

    // Apply existing text-based filters
    const matchesTextFilter =
      item?.Name.toLowerCase().includes(filterText.toLowerCase()) ||
      companyName?.toLowerCase().includes(filterText.toLowerCase()) ||
      departmentName?.toLowerCase().includes(filterText.toLowerCase()) ||
      categoryName?.toLowerCase().includes(filterText.toLowerCase()) ||
      desigName?.toLowerCase().includes(filterText.toLowerCase()) ||
      String(item?.Mobile).toLowerCase().includes(filterText.toLowerCase()) ||
      String(item?.Code).toLowerCase().includes(filterText.toLowerCase()) ||
      String(item?.Email).toLowerCase().includes(filterText.toLowerCase());

    // Apply PayScaleId filter
    let matchesPayScaleFilter = true;
    if (payScaleFilter === "null") {
      matchesPayScaleFilter = !item.PayScaleId || item.PayScaleId === "";
    } else if (payScaleFilter === "not-null") {
      matchesPayScaleFilter = item.PayScaleId && item.PayScaleId !== "";
    } // 'all' option requires no filtering

    return matchesTextFilter && matchesPayScaleFilter;
  });

  const openModal = (EmpId) => {
    setEmpIdToDelete(EmpId);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEmpIdToDelete(null);
    setShowOtpInput(false);
    setOtp("");
  };

  const confirmDeleteotp = async () => {
    const data = { UserId: UID };
    try {
      const response = await sendemployeedeletionotp(data);
      if (response?.data?.message === "OTP generated and sent successfully") {
        setShowOtpInput(true); // Show OTP input field
      } else {
        toast.error(response?.data?.message || "Unexpected error occurred.");
      }
    } catch (error) {
      console.error("Error occurred:", error);
      if (error.response) {
        // API responded with a status outside the 2xx range
        toast.error(error.response.data.error || "Bad Request");
      } else if (error.request) {
        // Request was made, but no response received
        toast.error("No response from server. Please try again later.");
      } else {
        // Other errors
        toast.error("An unexpected error occurred.");
      }
    }
  };
  const verifyOtpAndDelete = async () => {
    try {
      const data = {
        otp: otp,
        empId: EmpIdToDelete,
      };
      if (!DeleteEmployee) {
        throw new Error("DeleteEmployee function is undefined");
      }

      const result = await DeleteEmployee(data);
      if (result.data.success) {
        toast.success("Employee Deleted Successfully ");
        setOtp("");
        closeModal();
        fetchAllDetails();
      } else {
        toast.error(result.data.message || "something want wrong");
      }
    } catch (error) {
      console.error("Error in verifyOtpAndDelete:", error);
      toast.error(error.response.data.message || "something went wrong");
    }
  };

  const handleDownload = async (EmpId) => {
    try {
      // Here you would typically call an API endpoint to get the download data
      // For example:
      setLoading(true);
      const Data = {
        UserId: UID,
        EmpId,
      };
      const response = await downloadEmployeeData(Data);

      if (
        response.data &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        await generateEmployeePDF(response.data.data[0]);
        toast.success(`Employee data downloaded successfully`);
      } else {
        toast.error("No employee data found");
      }
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Failed to download employee data");
    } finally {
      setLoading(false);
    }
  };

  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "Name",
      selector: (row) => row.Name,
      sortable: true,
      grow: 0,
      width: "150px",
    },
    {
      name: "Code",
      selector: (row) => row.Code,
      sortable: true,
      grow: 0,
      width: "120px",
    },

    {
      name: "Department",
      selector: (row) => {
        const DepartmentName = department?.find(
          (el) => el.Id === row.DepartmentId
        );
        return DepartmentName ? DepartmentName.Name : "N/A";
      },
      grow: 0,
      width: "150px",
    },
    {
      name: "Category",
      selector: (row) => {
        const categoryName = category?.find((el) => el.Id === row.CategoryId);
        return categoryName ? categoryName.Name : "N/A"; // Handle case where category is not found
      },
      grow: 0,
      width: "150px",
    },
    {
      name: "Mobile",
      selector: (row) => row.Mobile,
      grow: 0,
      width: "150px",
    },

    {
      name: "Designation",
      selector: (row) => {
        const desigName = designation?.find(
          (el) => el.Id === row.DesignationId
        );
        return desigName ? desigName.Name : "N/A"; // Handle case where category is not found
      },
      sortable: true,
    },

    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            disabled={isAdmin == 0}
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => {
              openAddEmployeeModal(true, row); // Pass true for edit mode and the row data
              setEmployeeId(row.Id);
              setImagePreview(null);
            }}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            disabled={isAdmin == 0}
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            disabled={isAdmin == 0}
            className="bg-green-500 rounded-[4px] px-10 py-[8px]"
            onClick={() => handleDownload(row.Id)}
          >
            <IconDownload className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];

  const columnsFilter2 = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "Name",
      selector: (row) => row.Name,
      sortable: true,
      grow: 0,
      width: "150px",
    },
    {
      name: "Code",
      selector: (row) => row.Code,
      sortable: true,
      grow: 0,
      width: "120px",
    },
    {
      name: "Profit Center",
      selector: (row) => {
        const companyName = ProfitCenter?.find(
          (el) => el.Id === row.ProfitCenterId
        );
        return companyName ? companyName.Name : "N/A"; // Handle case where category is not found
      },
      grow: 0,
      width: "150px",
    },
    {
      name: "Employee Status",
      selector: (row) => {
        const companyName = employeeType?.find(
          (el) => el.ID === row?.EmpStatus
        );
        return companyName ? companyName.type : "N/A"; // Handle case where category is not found
      },
      grow: 0,
      width: "150px",
    },
    {
      name: "Department",
      selector: (row) => {
        const DepartmentName = department?.find(
          (el) => el.Id === row.DepartmentId
        );
        return DepartmentName ? DepartmentName.Name : "N/A";
      },
      grow: 0,
      width: "150px",
    },
    {
      name: "Category",
      selector: (row) => {
        const categoryName = category?.find((el) => el.Id === row.CategoryId);
        return categoryName ? categoryName.Name : "N/A"; // Handle case where category is not found
      },
      grow: 0,
      width: "150px",
    },
    {
      name: "Mobile",
      selector: (row) => row.Mobile,
      grow: 0,
      width: "150px",
    },

    {
      name: "Designation",
      selector: (row) => {
        const desigName = designation?.find(
          (el) => el.Id === row.DesignationId
        );
        return desigName ? desigName.Name : "N/A"; // Handle case where category is not found
      },
      sortable: true,
    },

    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => {
              openAddEmployeeModal(true, row); // Pass true for edit mode and the row data
              setEmployeeId(row.Id);
              setImagePreview(null);
            }}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-green-500 rounded-[4px] px-10 py-[8px]"
            onClick={() => handleDownload(row.Id)}
          >
            <IconDownload className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];

  const fetchAllDetails = async () => {
    try {
      const [employeeRes] = await Promise.all([employeeOne()]);
      const filteredData =
        isAdmin == 1
          ? employeeRes?.data?.data
          : employeeRes?.data?.data?.filter((el) => el?.DepartmentId == DepId);
      setEmployeeDetails(filteredData);
      setIsFilterVisible(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handlePayScaleFilterChange = (e) => {
    const value = e.target.value;
    setPayScaleFilter(value);
    setTemp({ ...temp, payScaleFilter: value }); // Persist in tempState
  };

  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults); // Update state with the filtered data
  };
  const handleChnageMobileActive = (e) => {
    const value = e.target.value;

    if (value === "All") {
      setDataFilter(employeeDetails);
    } else if (value === "Active") {
      setDataFilter(
        employeeDetails.filter(
          (el) =>
            String(el.MobileAppActivated) === "1" ||
            String(el.MobileAppActivated).toLowerCase() === "true"
        )
      );
    } else if (value === "Inactive") {
      setDataFilter(
        employeeDetails.filter(
          (el) =>
            String(el.MobileAppActivated) === "0" ||
            String(el.MobileAppActivated).toLowerCase() === "false" ||
            el.MobileAppActivated == null
        )
      );
    }
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const handleopenModalColor = () => {
    setModalOpenClr(true);
  };
  const ModalbackColor = () => {
    setModalOpenClr(false);
  };

  const handleDownloadPdf = (filteredItems, payScaleFilter) => {
    const PayScaleFiltervalue =
      payScaleFilter === "null"
        ? "Finance Not Entered"
        : payScaleFilter === "not-null"
        ? "Finance Entered"
        : payScaleFilter; // fallback to original value

    // Ensure filteredItems is an array
    if (!Array.isArray(filteredItems)) {
      console.error("filteredItems is not an array:", filteredItems);
      return;
    }

    // Group employees by department
    const groupedByDepartment = filteredItems.reduce((acc, employee) => {
      const dept = employee.DepartmentName || "Unassigned";
      if (!acc[dept]) {
        acc[dept] = [];
      }
      acc[dept].push(employee);
      return acc;
    }, {});

    // Create PDF with A3 size (landscape for better table display)
    const doc = new jsPDF("l", "mm", "a3"); // 'l' for landscape, 'a3' for A3 size

    // Get page dimensions
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 20;

    // Add Main Heading (Company Name)
    doc.setFontSize(24);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(40, 40, 40); // Dark gray

    const mainHeading = company[0].Name.toUpperCase();

    // Center the main heading
    const mainHeadingWidth = doc.getTextWidth(mainHeading);
    const mainHeadingX = (pageWidth - mainHeadingWidth) / 2;
    doc.text(mainHeading, mainHeadingX, 25);

    // Add Subheading
    doc.setFontSize(16);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(60, 60, 60); // Slightly lighter gray

    const subHeading = `${
      notfinanceemployee.length > 0
        ? "Employee Details On Finance Master Not Entered"
        : "Employee Details"
    }${temp ? ` ON, ${temp}` : ""}${
      PayScaleFiltervalue ? ` ${PayScaleFiltervalue}` : ""
    }`.toUpperCase();

    // Center the subheading
    const subHeadingWidth = doc.getTextWidth(subHeading);
    const subHeadingX = (pageWidth - subHeadingWidth) / 2;
    doc.text(subHeading, subHeadingX, 35);

    // Add a line under the headings
    doc.setLineWidth(0.5);
    doc.setDrawColor(200, 200, 200);
    doc.line(margin, 42, pageWidth - margin, 42);

    // Define Table Columns in the specified order
    const tableColumns = [
      "SN",
      "Employee Name",
      "Employee Code",
      "Profit Center",
      "Category",
      "Designation",
      "Mobile",
      "CurrentBasic",
    ];

    let startY = 52; // Initial Y position for the first table
    let totalEmployees = 0;

    // Process each department group
    Object.entries(groupedByDepartment).forEach(
      ([department, employees], deptIndex) => {
        // Add Department heading
        if (startY > pageHeight - 50) {
          doc.addPage();
          startY = margin;
        }

        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0);
        doc.text(`Department: ${department}`, margin, startY);
        startY += 10;

        // Generate Table Rows for this department in the specified column order
        const tableRows = employees.map((item, index) => [
          index + 1, // Serial number
          item.Name || "N/A", // Employee Name
          item.Code || "N/A", // Employee Code
          item.ProfitCenterName || "N/A", // Profit Center
          item.CategoryName || "N/A", // Category
          item.DesignationName || "N/A", // Designation
          item.Mobile || "N/A", // Mobile
          item.Currentbasicpay || "N/A",
        ]);

        totalEmployees += employees.length;

        // Create table for this department
        doc.autoTable({
          head: [tableColumns],
          body: tableRows,
          startY: startY,
          margin: { left: margin, right: margin },

          // Table styling
          styles: {
            fontSize: 11,
            cellPadding: 3,
            lineColor: [0, 0, 0], // Black borders
            lineWidth: 0.5,
            textColor: [0, 0, 0], // Black text
            font: "helvetica",
            overflow: "linebreak", // Handle text overflow
            halign: "left", // Default horizontal alignment
            valign: "middle", // Vertical alignment
            minCellHeight: 8, // Reduced row height
          },

          // Header styling
          headStyles: {
            fillColor: [240, 240, 240], // Light gray background
            textColor: [0, 0, 0], // Black text
            fontSize: 12,
            fontStyle: "bold",
            halign: "center",
            valign: "middle",
            lineWidth: 0.5,
            lineColor: [0, 0, 0], // Black borders
            minCellHeight: 10,
          },

          // Body styling
          bodyStyles: {
            fillColor: [255, 255, 255], // White background for rows
            textColor: [0, 0, 0], // Black text
            fontSize: 11,
            minCellHeight: 8, // Reduced row height
          },

          // Alternating row colors
          alternateRowStyles: {
            fillColor: [250, 250, 250], // Very light gray background for alternate rows
          },

          // Column-specific styling optimized for new column order
          columnStyles: {
            0: { halign: "center", cellWidth: 20 }, // SN - fixed width
            1: { halign: "left", cellWidth: "auto" }, // Employee Name
            2: { halign: "center", cellWidth: 35 }, // Employee Code
            3: { halign: "center", cellWidth: "auto" }, // Profit Center
            4: { halign: "left", cellWidth: "auto" }, // Category
            6: { halign: "left", cellWidth: "auto" }, // Designation
            7: { halign: "center", cellWidth: 45 }, // Mobile
          },

          // Table border styling
          tableLineColor: [0, 0, 0], // Black table borders
          tableLineWidth: 0.5,

          // Page break handling
          showHead: "everyPage",

          // Custom draw hooks for additional styling
          didDrawPage: function (data) {
            // Add page numbers
            doc.setFontSize(8);
            doc.setTextColor(128, 128, 128);
            doc.text(
              "Page " + doc.internal.getNumberOfPages(),
              pageWidth - margin - 20,
              pageHeight - 10
            );

            // Add generation date
            const currentDate = new Date();
            const formattedDate = `${currentDate
              .getDate()
              .toString()
              .padStart(2, "0")}/${(currentDate.getMonth() + 1)
              .toString()
              .padStart(2, "0")}/${currentDate.getFullYear()}`;
            doc.text(`Generated on: ${formattedDate}`, margin, pageHeight - 10);
          },

          // Handle content overflow
          didParseCell: function (data) {
            // Ensure text fits within cell
            if (data.cell.text && data.cell.text.length > 0) {
              const cellText = data.cell.text[0];
              if (cellText && cellText.length > 25) {
                // Truncate very long text and add ellipsis
                data.cell.text = [cellText.substring(0, 22) + "..."];
              }
            }
          },
        });

        // Update startY position for next department
        startY = doc.lastAutoTable.finalY + 15;
      }
    );

    // Add footer with total count
    const finalY = doc.lastAutoTable.finalY + 15;
    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100);
    doc.text(`Total Employees: ${totalEmployees}`, margin, finalY);

    // Save the PDF with descriptive filename
    const timestamp = new Date().toISOString().slice(0, 10);
    doc.save(`EmployeeDetails_${timestamp}.pdf`);
  };

  const handleDownloadPdfCard = async (filteredItems) => {
    if (!Array.isArray(filteredItems) || filteredItems.length === 0) {
      console.error("Invalid or empty filteredItems:", filteredItems);
      return;
    }

    // Set loading state
    setLoadingpdf(true);

    try {
      // Pre-validate and cache images
      const validatedEmployees = await validateEmployeeImages(filteredItems);

      // Generate PDF with validated data
      await generatePDFWithValidatedData(validatedEmployees);
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Failed to generate PDF. Please try again.");
    } finally {
      setLoadingpdf(false);
    }
  };
  // Function to validate images and cache results
  const validateEmployeeImages = async (employees) => {
    const imageCache = new Map();
    const validatedEmployees = [];

    // Process employees in batches to avoid overwhelming the server
    const batchSize = 10;
    const totalBatches = Math.ceil(employees.length / batchSize);

    for (let i = 0; i < totalBatches; i++) {
      const batch = employees.slice(i * batchSize, (i + 1) * batchSize);

      // Process batch concurrently but with limited concurrent requests
      const batchPromises = batch.map(async (employee) => {
        const validatedEmployee = { ...employee };

        if (employee.ProfilePicture) {
          const imageUrl = `${IMAGE_URL}/${employee.ProfilePicture}`;

          // Check cache first
          if (imageCache.has(imageUrl)) {
            validatedEmployee.validImageUrl = imageCache.get(imageUrl);
          } else {
            // Validate image URL
            const isValid = await validateImageUrl(imageUrl);
            imageCache.set(imageUrl, isValid ? imageUrl : null);
            validatedEmployee.validImageUrl = isValid ? imageUrl : null;
          }
        } else {
          validatedEmployee.validImageUrl = null;
        }

        return validatedEmployee;
      });

      const batchResults = await Promise.all(batchPromises);
      validatedEmployees.push(...batchResults);

      // Optional: Show progress
    }

    return validatedEmployees;
  };

  // Function to validate if image URL is accessible
  const validateImageUrl = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      const timeout = setTimeout(() => {
        resolve(false);
      }, 3000); // 3 second timeout

      img.onload = () => {
        clearTimeout(timeout);
        resolve(true);
      };

      img.onerror = () => {
        clearTimeout(timeout);
        resolve(false);
      };

      img.src = url;
    });
  };

  // Generate PDF with pre-validated data
  const generatePDFWithValidatedData = async (validatedEmployees) => {
    // Initialize jsPDF with A4 portrait
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    // Constants for A4 layout (210 x 297 mm)
    const pageWidth = 210;
    const pageHeight = 297;
    const margin = 15;
    const cardsPerRow = 4;
    const rowsPerPage = 5;
    const maxCardsPerPage = cardsPerRow * rowsPerPage;
    const cardSpacing = 8;
    const headerHeight = 20;
    const footerHeight = 15;

    // Calculate available space for cards
    const availableWidth = pageWidth - margin * 2;
    const availableHeight = pageHeight - margin - headerHeight - footerHeight;

    const cardWidth =
      (availableWidth - cardSpacing * (cardsPerRow - 1)) / cardsPerRow;
    const cardHeight =
      (availableHeight - cardSpacing * (rowsPerPage - 1)) / rowsPerPage;

    let cardCount = 0;

    const addHeader = (department) => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.setTextColor(0, 0, 0);
      const title = "EMPLOYEE DETAILS";
      const titleWidth = doc.getTextWidth(title);
      const titleX = (pageWidth - titleWidth) / 2;
      doc.text(title, titleX, margin + 5);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text(`${department}`, margin + 5, margin + 15);

      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.5);
      doc.line(
        margin,
        margin + headerHeight - 2,
        pageWidth - margin,
        margin + headerHeight - 2
      );
    };

    const addFooter = (currentPage, totalPages) => {
      const footerY = pageHeight - 10;

      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.3);
      doc.line(margin, footerY - 5, pageWidth - margin, footerY - 5);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(0, 0, 0);
      doc.text(
        `Page ${currentPage} of ${totalPages}`,
        pageWidth - margin - 25,
        footerY
      );

      const timestamp = new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
      doc.text(`Generated: ${timestamp}`, margin, footerY);
    };

    const addNewPage = () => {
      doc.addPage();
      cardCount = 0;
    };

    const drawEmployeeCard = (employee, xOffset, yOffset) => {
      // Simple card border
      doc.setFillColor(255, 255, 255);
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.5);
      doc.rect(xOffset, yOffset, cardWidth, cardHeight, "FD");

      // Profile picture section
      const imgSize = 20;
      const imgXOffset = xOffset + (cardWidth - imgSize) / 2;
      const imgYOffset = yOffset + 5;

      if (employee.validImageUrl) {
        try {
          doc.addImage(
            employee.validImageUrl,
            "JPEG",
            imgXOffset,
            imgYOffset,
            imgSize,
            imgSize
          );
        } catch (error) {
          console.error("Error adding image to PDF:", error);
          drawPlaceholder();
        }
      } else {
        drawPlaceholder();
      }

      function drawPlaceholder() {
        doc.setFillColor(240, 240, 240);
        doc.setDrawColor(0, 0, 0);
        doc.rect(imgXOffset, imgYOffset, imgSize, imgSize, "FD");
        doc.setFontSize(6);
        doc.setTextColor(0, 0, 0);
        doc.text(
          "No Photo",
          imgXOffset + imgSize / 2 - 7,
          imgYOffset + imgSize / 2 + 1
        );
      }

      // Employee details section
      const textStartY = yOffset + imgSize + 12;

      // Name + Code
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      const name = employee.Name || "Unknown";
      const code = employee.Code || "N/A";
      const nameCode = `${name} (${code})`;

      const availableTextWidth = cardWidth - 4;
      const nameCodeSplit = doc.splitTextToSize(nameCode, availableTextWidth);

      for (let i = 0; i < Math.min(nameCodeSplit.length, 2); i++) {
        const lineWidth = doc.getTextWidth(nameCodeSplit[i]);
        const lineX = xOffset + (cardWidth - lineWidth) / 2;
        doc.text(nameCodeSplit[i], lineX, textStartY + i * 4);
      }

      // Designation
      const bottomMargin = 3;
      const designationY = yOffset + cardHeight - bottomMargin;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.setTextColor(0, 0, 0);
      const designation = employee.DesignationName || "No Designation";

      const designationSplit = doc.splitTextToSize(
        designation,
        availableTextWidth
      );
      const designationLine = designationSplit[0];
      const designationWidth = doc.getTextWidth(designationLine);
      const designationX = xOffset + (cardWidth - designationWidth) / 2;
      doc.text(designationLine, designationX, designationY);
    };

    // Group employees by department
    const groupedData = validatedEmployees.reduce((groups, item) => {
      const department = item.DepartmentName || "Unassigned";
      groups[department] = groups[department] || [];
      groups[department].push(item);
      return groups;
    }, {});

    let isFirstDepartment = true;

    // Iterate through departments
    Object.entries(groupedData).forEach(([department, employees]) => {
      if (!isFirstDepartment) {
        addNewPage();
      }
      isFirstDepartment = false;

      addHeader(department);

      employees.forEach((employee, index) => {
        if (cardCount === maxCardsPerPage) {
          addNewPage();
          addHeader(department);
        }

        const col = cardCount % cardsPerRow;
        const row = Math.floor(cardCount / cardsPerRow);

        const xOffset = margin + col * (cardWidth + cardSpacing);
        const yOffset =
          margin + headerHeight + row * (cardHeight + cardSpacing);

        drawEmployeeCard(employee, xOffset, yOffset);
        cardCount++;
      });
    });

    // Add footers to all pages
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      addFooter(i, totalPages);
    }

    // Save PDF
    const timestamp = new Date().toISOString().slice(0, 10).replace(/-/g, "");
    doc.save(`EmployeeCards_${timestamp}.pdf`);
  };

  useEffect(() => {
    const fetchDesignation = async () => {
      try {
        const response = await getDesignation(UID);
        setDesignation(response.data.data);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetchDesignation();
  }, []);

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await getDepartments(UID);
        setDepartment(response.data.data);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetchDepartment();
  }, []);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await getCompanys(UID);

        setCompany(response.data.data);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetchCompany();
  }, []);

  useEffect(() => {
    const fetchCommonDatas = async () => {
      setLoading(true); // Set loading to true when starting the fetch
      try {
        const response = await getProfitCenter(UID);
        setProfitCenter(response.data.data);
      } catch (error) {
        console.error("Error fetching deparments :", error);
      } finally {
        setLoading(false); // Set loading to false once fetch is complete
      }
    };

    fetchCommonDatas();
  }, []);

  useEffect(() => {
    if (notfinanceemployee.length && employeeDetails.length) {
      const LeaveFromDashBoard = employeeDetails.filter((el) =>
        notfinanceemployee.some((p) => p.Id === el.Id)
      );

      setEmployeeDetails(LeaveFromDashBoard);
    }
  }, [notfinanceemployee]);

  useEffect(() => {
    fetchAllDetails();
  }, [isAddEmployeeVisible]);
  useEffect(() => {}, [location.state]);

  useEffect(() => {
    const employees = location.state?.notfinanceemployee || employeeDetails;

    if (Array.isArray(employees) && employees.length > 0) {
      const updatedData = employees.map((item, index) => {
        const DepartmentName =
          department.find((dept) => dept.id === item.DepartmentId)?.Name || "";

        return {
          Slno: index + 1,
          Id: item.Id || "",
          Name: item.Name || "",
          Narration: item.Narration || "",
          GenderId: item.GenderId || "",
          Email: item.Email || "",
          DOJ: item?.DOJ || "",
          DOB: item?.DOB || "",
          Mobile: item.Mobile || "",
          Mobile2: item.Mobile2 || "",
          DOR: item?.DOR || "",
          ProfitCenterId: item.ProfitCenterId || "",
          DepartmentId: item.DepartmentId || "",
          DepartmentName,
          CategoryId: item.CategoryId || "",
          GroupId: item.GroupId || "",
          DesignationId: item.DesignationId || "",
          EmployTypeId: item.EmployTypeId || "",
          PayScaleId: item.PayScaleId || "",
          SalaryGeneration: item.SalaryGeneration || "",
          ContractEndDate: item.ContractEndDate || "",
          Code: item.Code || "",
          EmployeeId: item.EmployeeId || "",
          IncrementDate: item.IncrementDate || "",
          CompanyId: item.CompanyId || "",
          AadharNo: item.AadharNo || "",
          DesignationName: item.DesignationName || "",
          ProfitCenterName: item.ProfitCenterName || "",
          DesignationName: item.DesignationName || "",
          DepartmentName: item.DepartmentName || "",
          ProfilePicture: item.ProfilePicture || "",
          CategoryName: item.CategoryName || "",
          Currentbasicpay: item.Currentbasicpay || "",
          MobileAppActivated: item.MobileAppActivated || "",
          RecomentedColor: item.RecomentedColor || "",
        };
      });

      setDataFilter(updatedData);
      setEmployee(updatedData);
    } else {
      setDataFilter([]);
    }
  }, [location.state?.notfinanceemployee, employeeDetails, department]);

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await getCategorys(UID);
        setCategory(response.data.data);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    const fetchEmpType = async () => {
      try {
        const data = await getEmpStatus(UID);
        setEmployeeType(data.data.data);
      } catch (error) {
        console.error("Error fetching shifts", error);
      }
    };
    fetchEmpType();
    fetchCategory();
  }, []);

  return (
    <>
      {moadaopenClr && (
        <div className="fixed inset-0 flex justify-center items-center bg-opacity-60 backdrop-blur-sm z-[1000]">
          <div className="p-8 rounded-xl shadow-xl bg-white w-[700px] max-h-[550px] flex flex-col">
            <div className="flex justify-between items-center border-b pb-3 mb-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                Color Codes
              </h2>
            </div>
            <div className="flex-grow overflow-y-auto max-h-[450px] pr-4">
              <div className="space-y-4">
                <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div
                    className="w-8 h-8 rounded-full"
                    style={{ backgroundColor: "rgba(255, 99, 71, 0.8)" }}
                  ></div>
                  <div className="ml-4">
                    <p className="font-medium">Finance Master Not Entered</p>
                    <p className="text-sm text-gray-500">
                      Employees missing finance master data.
                    </p>
                  </div>
                </div>

                <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div
                    className="w-8 h-8 rounded-full"
                    style={{ backgroundColor: "rgba(88, 86, 86, 0.7)" }}
                  ></div>
                  <div className="ml-4">
                    <p className="font-medium">Transferred</p>
                    <p className="text-sm text-gray-500">
                      Employees who have been transferred.
                    </p>
                  </div>
                </div>

                <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div
                    className="w-8 h-8 rounded-full"
                    style={{ backgroundColor: "rgb(252, 66, 66)" }}
                  ></div>
                  <div className="ml-4">
                    <p className="font-medium">Dismissed</p>
                    <p className="text-sm text-gray-500">
                      Employees who are dismissed.
                    </p>
                  </div>
                </div>

                <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div
                    className="w-8 h-8 rounded-full"
                    style={{ backgroundColor: "rgb(118, 109, 241)" }}
                  ></div>
                  <div className="ml-4">
                    <p className="font-medium">Retired</p>
                    <p className="text-sm text-gray-500">
                      Employees who are retired.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-end mt-6">
              <button
                className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 transition"
                onClick={ModalbackColor}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              OTP Required for Employee Deletion
            </p>

            {showOtpInput ? (
              // OTP Input Section
              <div>
                <input
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="Enter OTP"
                  className="border rounded-md px-3 py-2 w-full mb-4 text-center"
                />
                <div className="flex justify-end">
                  <button
                    className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    className="bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600 transition-colors"
                    type="button"
                    onClick={() => {
                      verifyOtpAndDelete();
                    }}
                  >
                    Confirm Deletion
                  </button>
                </div>
              </div>
            ) : (
              // Send OTP Button Section
              <div className="flex justify-end">
                <button
                  className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button
                  className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                  onClick={confirmDeleteotp}
                >
                  Send OTP
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      <Breadcrumb
        title={
          notfinanceemployee.length > 0
            ? "Employee Finance master not entered"
            : "Employee Details"
        }
      />
      <div className="flex flex-wrap items-end gap-4 bg-gray-100 rounded p-5 w-full">
        {notfinanceemployee.length > 0 && (
          <Link to={"/"}>
            <button className="btn btn-danger">Back to Dashboard</button>
          </Link>
        )}

        {/* Finance Filter */}
        <div className="flex flex-col gap-2 min-w-[200px]">
          <label className="font-medium text-gray-700">Finance</label>
          <select
            name="payScaleFilter"
            value={payScaleFilter}
            onChange={handlePayScaleFilterChange}
            className="p-2 rounded border border-gray-300 bg-white"
          >
            <option value="all">All</option>
            <option value="null">Finance Not Entered</option>
            <option value="not-null">Finance Entered</option>
          </select>
        </div>

        {/* Search */}
        <div className="flex flex-col gap-2 min-w-[300px] flex-1">
          <label className="font-medium text-gray-700">Search</label>
          <div className="flex items-center gap-2">
            <input
              type="text"
              id="search"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
              placeholder="Name / Code / Mobile / Dept / Category / Designation"
              className="flex-1 min-w-[200px] px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <button onClick={handleClear} className="btn btn-danger">
              Clear
            </button>
            <button
              onClick={handleopenModalColor}
              className="btn btn-success px-3 py-2 whitespace-nowrap text-sm"
            >
              Show Color Info
            </button>
            <button
              className="bg-sky rounded-[4px] px-3 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
          </div>
        </div>

        {/* Mobile App Filter */}
        <div className="flex flex-col gap-2 min-w-[200px]">
          <label className="font-medium text-gray-700">Mobile App Status</label>
          <select
            onChange={handleChnageMobileActive}
            className="p-2 rounded border border-gray-300 bg-white"
          >
            <option value="All">All</option>
            <option value="Active">Mobile App Activated</option>
            <option value="Inactive">Mobile App Not Activated</option>
          </select>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center gap-2">
          <button
            onClick={() => handleDownloadPdf(filteredItems, payScaleFilter)}
            className="btn btn-success"
          >
            PDF
          </button>
          <button
            onClick={() => handleDownloadPdfCard(filteredItems)}
            className="btn btn-success"
            disabled={loading}
          >
            {loadingpdf ? "Downloading" : "PDF Card"}
          </button>
          <button
            disabled={isAdmin == 0}
            onClick={() => openAddEmployeeModal(false)}
            className="btn btn-primary"
          >
            Add
          </button>
        </div>
      </div>
      {isFilterVisible && (
        <FilterComponent
          columns={columnsFilter2}
          data={
            notfinanceemployee.length > 0 ? notfinanceemployee : employeeDetails
          }
          onFilter={handleFilter}
          temp={temp}
          setTemp={setTemp}
        />
      )}

      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">
        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationDefaultPage={currentPage}
                onChangePage={handlePageChange}
                paginationPerPage={30}
                paginationResetDefaultPage={resetPaginationToggle}
                conditionalRowStyles={[
                  {
                    when: (row) => {
                      return row.RecomentedColor == "lightred";
                    },
                    style: {
                      backgroundColor: "rgba(255, 99, 71, 0.2) !important", // Light red background
                    },
                  },
                  {
                    when: (row) => {
                      return row.RecomentedColor == "gray";
                    },
                    style: {
                      backgroundColor: "rgba(88, 86, 86, 0.2) !important", // Light red background
                    },
                  },
                  {
                    when: (row) => {
                      return row.RecomentedColor == "lightblue";
                    },
                    style: {
                      backgroundColor: "rgb(118, 109, 241) !important", // Light red background
                    },
                  },
                  {
                    when: (row) => {
                      return row.RecomentedColor == "darkred";
                    },
                    style: {
                      backgroundColor: "rgb(252, 66, 66) !important", // Light red background
                    },
                  },
                ]}
              />
            )}
          </div>
        </div>
      </div>

      {/* Modal */}
      {isAddEmployeeVisible && (
        <div
          className={`fixed p-15 w-full max-w-[] left-[60%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6] rounded-lg`}
        >
          <AddEmployeeModal
            isVisible={isAddEmployeeVisible}
            setEmployeeDetails={setEmployeeDetails}
            employeeDetails={employeeDetails}
            personalDetails={personalDetails}
            setPersonalDetails={setPersonalDetails}
            bankDetails={bankDetails}
            documentDetails={documentDetails}
            onClose={closeAddEmployeeModal}
            isEdit={isEdit}
            EmpId={employeeId}
          />
        </div>
      )}

      {isAddEmployeeVisible && (
        <div className="fixed inset-0 backdrop-blur-sm z-[5]" />
      )}
    </>
  );
}
